






































































































































































import { Prop, Component, Watch, Mixins } from 'vue-property-decorator';
import { Button, Checkbox, Form, FormItem, Option, Select } from 'element-ui';
import NullableInput from '@/components/element-ui/NullableInput.vue';
import ModalCard from '@/components/layout/ModalCard.vue';

import upsertCustomerOrganization from '@/graphql/mutations/customerOrganization/Upsert.gql';

// mixins
import countries from '@/mixins/countryOptions';
import scrollError from '@/mixins/scrollError';

import { languageOptions } from '@/constants/languages';

import rules from '@/rules/rules';

import { CustomerOrganizationInput, LanguageEnum } from '@/types/graphql/schemaTypes';

@Component({
  components: {
    ModalCard,
    'el-button': Button,
    'el-checkbox': Checkbox,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': NullableInput,
    'el-option': Option,
    'el-select': Select
  }
})
export default class CustomerCreate extends Mixins(countries, scrollError) {
  @Prop({ default: false, type: Boolean }) open!: boolean;

  customerOrganizationInput: CustomerOrganizationInput = {
    address: {},
    language: LanguageEnum.ja
  };

  loading = false;

  readonly languageOptions = languageOptions();
  readonly rules = rules;

  $refs!: {
    customerForm: HTMLFormElement;
  };

  submit(): void {
    this.$refs.customerForm.validate(async(valid: boolean) => {
      if (!valid || !this.customerOrganizationInput) {
        this.scrollError(this.$refs.customerForm);
        return;
      }

      this.loading = true;
      try {
        const response = await this.$apollo.mutate({
          mutation: upsertCustomerOrganization,
          variables: {
            organizationArgs: this.customerOrganizationInput
          }
        });

        if (response) {
          this.$emit('close');
          this.$emit('refresh');
          this.$store.dispatch('Alert/addAlert', {
            type: 'success',
            message: this.$t('success.updated'),
            time: 2000
          });
        }
      } catch (err) {
        const gqlError = err.graphQLErrors[0];

        let message = this.$t('error.push');
        if (gqlError?.extensions?.code === 'user_already_exists') {
          message = this.$t('customer.error.already-exists');
        }
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message,
          time: 2000
        });
      } finally {
        this.loading = false;
      }
    });
  }

  @Watch('open')
  defaultValue() {
    if (open) {
      this.$refs.customerForm.resetFields();
    }
  }
}
